import React from 'react';
import ReactDOM from 'react-dom/client';
import './CSS/index.css';
import Main from './Main';
import reportWebVitals from './reportWebVitals';
import './Javascript/Arc.js'
import './Javascript/Navigation.js'
import './Javascript/MapOverlays.js'
import './Javascript/GenerateReport.js'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
